import React from "react";
import { connect } from "react-redux";

const mapState = (state) => {
	return {
		familiar : state.af.familiar,
		paso: state.af.pasoInvitado,
	};
};

const mapDispatch = (dispatch) => {
	return {
		pasoInvitado: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO_INVITADO", "pasoInvitado": paso });
		},
		addEvento: (evento) => {
			dispatch({ "type": "AF_SET_EVENT", "evento": evento});
		}
	};
};

class InvitacionEnviada extends React.Component {

	close = () => {
		$("#modal-gestionar").modal("hide");
		$("#modal-invitar").modal("hide");
		this.props.addEvento("BtnAceptar-InvitacionEnviada");
		this.props.pasoInvitado(0);
	}

	render() {
		return (
			<div>
				<img src={ require("../img/icon-send.svg") }/>
				<h5 className="invitacion-title">Invitación enviada</h5>
				<p>¡Listo! tu invitación ha sido enviada a {this.props.familiar.email}, en breve recibirá un correo para poder visualizar tus pólizas. Podrás agregar y eliminar invitados cuándo lo desees.</p>
				<div className="text-center aceptar-cancelar-btn mt-38 mb-20">
					<a onClick={this.close.bind(this)} className="orange-btn">Aceptar</a>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(InvitacionEnviada);



// WEBPACK FOOTER //
// ./src/acceso-familiar/InvitacionEnviada.cmpt.js